"use strict";

var _slicedToArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var optim_1 = require("../optim");

var fastpriorityqueue_1 = __importDefault(require("fastpriorityqueue"));

var directionRight = {
  north: "east",
  east: "south",
  south: "west",
  west: "north"
};
var directionLeft = {
  north: "west",
  east: "north",
  south: "east",
  west: "south"
};
var directionReverse = {
  north: "south",
  east: "west",
  south: "north",
  west: "east"
};

function boundsContain(bounds, x, y) {
  return bounds.x <= x && x <= bounds.X && bounds.y <= y && y <= bounds.Y;
}

function manhattanDistance(u, v) {
  return Math.abs(u.x - v.x) + Math.abs(u.y - v.y);
}

function costFn(length, bends, penalities) {
  return length + 1000 * bends + penalities;
}

function lengthHeuristic(vertex, end) {
  return manhattanDistance(vertex, end);
}

function bendsHeuristic(vertex, end) {
  return 0; // TODO
}
/**
 * Penalty per length of segment within source/target nodes. Encourages routes from ports to go
 * around the node rather than through it.
 */


var kSourceTargetPenalty = 1000;
/**
 * Penalty per length of segment overlapping with any node. Encourages routes to use blank areas.
 */

var kOverlapPenalty = 0.1;
/**
 * An `OrthogonalRouter` converts edge paths from straight segments of any orientation into
 * orthogonal routes of only horizontal/vertical segments.
 */

var OrthogonalRouter =
/*#__PURE__*/
function () {
  function OrthogonalRouter(storage) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$nodeMargin = _ref.nodeMargin,
        nodeMargin = _ref$nodeMargin === void 0 ? 8 : _ref$nodeMargin,
        _ref$edgeGap = _ref.edgeGap,
        edgeGap = _ref$edgeGap === void 0 ? 4 : _ref$edgeGap,
        _ref$outerGap = _ref.outerGap,
        outerGap = _ref$outerGap === void 0 ? 8 : _ref$outerGap;

    _classCallCheck(this, OrthogonalRouter);

    this.storage = storage;
    this._config = {
      nodeMargin: nodeMargin,
      edgeGap: edgeGap,
      outerGap: outerGap
    };
  }
  /**
   * Runs the routing procedure on the edges, making in-place changes.
   */


  _createClass(OrthogonalRouter, [{
    key: "route",
    value: function route() {
      var _this = this;

      // This code implements the algorithms described in "Orthogonal Connector Routing"
      // (Wybrow et al, 2009). It uses a 3-phase approach:
      // (1) an orthogonal visibility graph is constructed by intersecting "interesting"
      //     horizontal/vertical line segments
      // (2) the optimal routes are found using A* search
      // (3) any overlapping routes are ordered and nudged apart
      //
      // Design decisions:
      // (1) Ports at 'center' are treated specially because the corresponding lines need
      //     to emanate in both directions, along both vertical and horizontal axes. Other port 
      //     lines only emanate in a single direction along the axis perpendicular to the side.
      // (2) Edges with endpoints at ports on 'boundary' keep the same port, rather than be
      //     retargeted to a more convenient side. This is because: (a) multiple edges may target
      //     the same port, so routing cannot proceed independently, (b) ports can't be moved
      //     as that would break their constraint on the shape boundary.
      if (Array.from(this.storage.nodes()).length === 0) return; // =========================================================================================
      // Phase 1: Get visibility graph.

      console.log("Phase 1: Get visibility graph.");
      var vertices = [];
      var portToVertex = new Map();
      var hlines = [];
      var vlines = []; // Add graph bound lines.

      var graphBounds = {
        x: Number.POSITIVE_INFINITY,
        X: Number.NEGATIVE_INFINITY,
        y: Number.POSITIVE_INFINITY,
        Y: Number.NEGATIVE_INFINITY
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.storage.nodes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;

          var _node$shape$bounds = node.shape.bounds(),
              x = _node$shape$bounds.x,
              X = _node$shape$bounds.X,
              y = _node$shape$bounds.y,
              Y = _node$shape$bounds.Y;

          graphBounds.x = Math.min(x - this._config.outerGap, graphBounds.x);
          graphBounds.y = Math.min(y - this._config.outerGap, graphBounds.y);
          graphBounds.X = Math.max(X + this._config.outerGap, graphBounds.X);
          graphBounds.Y = Math.max(Y + this._config.outerGap, graphBounds.Y);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      hlines.push({
        y: graphBounds.y,
        x0: graphBounds.x,
        x1: graphBounds.X,
        vertices: []
      });
      hlines.push({
        y: graphBounds.Y,
        x0: graphBounds.x,
        x1: graphBounds.X,
        vertices: []
      });
      vlines.push({
        x: graphBounds.x,
        y0: graphBounds.y,
        y1: graphBounds.Y,
        vertices: []
      });
      vlines.push({
        x: graphBounds.X,
        y0: graphBounds.y,
        y1: graphBounds.Y,
        vertices: []
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop3 = function _loop3() {
          var u = _step2.value;

          // Add node bound lines.
          var _u$shape$bounds = u.shape.bounds(),
              x = _u$shape$bounds.x,
              X = _u$shape$bounds.X,
              y = _u$shape$bounds.y,
              Y = _u$shape$bounds.Y;

          hlines.push({
            y: y - _this._config.nodeMargin,
            x0: graphBounds.x,
            x1: graphBounds.X,
            vertices: []
          });
          hlines.push({
            y: Y + _this._config.nodeMargin,
            x0: graphBounds.x,
            x1: graphBounds.X,
            vertices: []
          });
          vlines.push({
            x: x - _this._config.nodeMargin,
            y0: graphBounds.y,
            y1: graphBounds.Y,
            vertices: []
          });
          vlines.push({
            x: X + _this._config.nodeMargin,
            y0: graphBounds.y,
            y1: graphBounds.Y,
            vertices: []
          }); // Add node midpoint lines.

          var cx = u.center.x,
              cy = u.center.y;
          var center = {
            x: cx,
            y: cy,
            neighbors: {},
            node: u
          };
          vertices.push(center);
          hlines.push({
            y: cy,
            x0: graphBounds.x,
            x1: graphBounds.X,
            vertices: [center]
          });
          vlines.push({
            x: cx,
            y0: graphBounds.y,
            y1: graphBounds.Y,
            vertices: [center]
          });
          portToVertex.set(u.center, center); // Add port lines.

          Object.values(u.ports).forEach(function (_ref6) {
            var point = _ref6.point,
                location = _ref6.location;

            if (location === "center") {
              // For all 'center' ports, add to existing center vertex.
              portToVertex.set(point, center);
            } else {
              // For all other ports, create new vertex and line emanating outwards.
              // TODO: Make emanate outwards.
              var v = {
                x: point.x,
                y: point.y,
                neighbors: {},
                node: u
              };
              vertices.push(v);
              portToVertex.set(point, v);

              switch (location) {
                case 'north':
                case 'south':
                  vlines.push({
                    x: point.x,
                    y0: graphBounds.y,
                    y1: graphBounds.Y,
                    vertices: [v]
                  });
                  break;

                case 'east':
                case 'west':
                  hlines.push({
                    y: point.y,
                    x0: graphBounds.x,
                    x1: graphBounds.X,
                    vertices: [v]
                  });
                  break;
              }
            }
          });
        };

        for (var _iterator2 = this.storage.nodes()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop3();
        } // // Add alley midpoint lines.
        // const visited: Set<Node> = new Set();
        // for(let u of this.storage.nodes()) {
        //     visited.add(u);
        //     for(let v of this.storage.nodes()) {
        //         if(visited.has(v)) continue;
        //         const ubounds = u.shape.bounds();
        //         const vbounds = v.shape.bounds();
        //         if(ubounds.X < vbounds.x) {
        //             // Vertical alley between u and v.
        //             if(vbounds.x - ubounds.X < 2 * this._config.nodeMargin) continue;
        //             vlines.push({
        //                 x: (ubounds.X + vbounds.x) / 2,
        //                 y0: graphBounds.y,
        //                 y1: graphBounds.Y,
        //                 vertices: [],
        //             });
        //         } else if(vbounds.X < ubounds.x) {
        //             // Vertical alley between v and u.
        //             if(ubounds.x - vbounds.X < 2 * this._config.nodeMargin) continue;
        //             vlines.push({
        //                 x: (vbounds.X + ubounds.x) / 2,
        //                 y0: graphBounds.y,
        //                 y1: graphBounds.Y,
        //                 vertices: [],
        //             });
        //         }
        //         if(ubounds.Y < vbounds.y) {
        //             // Horizontal alley between u and v.
        //             if(vbounds.y - ubounds.Y < 2 * this._config.nodeMargin) continue;
        //             hlines.push({
        //                 y: (ubounds.Y + vbounds.y) / 2,
        //                 x0: graphBounds.x,
        //                 x1: graphBounds.X,
        //                 vertices: [],
        //             });
        //         } else if(vbounds.Y < ubounds.y) {
        //             // Horizontal alley between v and u.
        //             if(ubounds.y - vbounds.Y < 2 * this._config.nodeMargin) continue;
        //             hlines.push({
        //                 y: (vbounds.Y + ubounds.y) / 2,
        //                 x0: graphBounds.x,
        //                 x1: graphBounds.X,
        //                 vertices: [],
        //             });
        //         }
        //     }
        // }
        // TODO: Prioritize alleys.
        // TODO: Alley computation is too expensive rn.
        // TODO: Cut off rays at obstacles / edge of graph.
        // Intersect lines and assign to nodes.

      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var frontToBack = this.storage.hierarchicalSort().reverse();
      hlines.forEach(function (hline) {
        vlines.forEach(function (vline) {
          if (hline.y < vline.y0 || hline.y > vline.y1 || vline.x < hline.x0 || vline.x > hline.x1) return;
          var vertex = {
            x: vline.x,
            y: hline.y,
            neighbors: {}
          }; // Assign vertex to frontmost node that contains it.

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = frontToBack[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var u = _step3.value;

              if (boundsContain(u.shape.bounds(), vertex.x, vertex.y)) {
                vertex.node = u;
                break;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          vertices.push(vertex);
          hline.vertices.push(vertex);
          vline.vertices.push(vertex);
        });
      }); // Connect adjacent vertices.

      hlines.forEach(function (hline) {
        hline.vertices.sort(function (a, b) {
          return a.x - b.x;
        });

        for (var i = 1; i < hline.vertices.length; i++) {
          var a = hline.vertices[i - 1],
              b = hline.vertices[i];
          a.neighbors.east = b;
          b.neighbors.west = a;
        }
      });
      vlines.forEach(function (vline) {
        vline.vertices.sort(function (a, b) {
          return a.y - b.y;
        });

        for (var i = 1; i < vline.vertices.length; i++) {
          var a = vline.vertices[i - 1],
              b = vline.vertices[i];
          a.neighbors.south = b;
          b.neighbors.north = a;
        }
      });
      console.log(vertices, portToVertex); // =========================================================================================
      // Phase 2: Get optimal routes.

      console.log("Phase 2: Get optimal routes.");
      var routes = new Map();
      this.storage.edges().forEach(function (edge) {
        // Routes may only pass through vertices that are attached to (1) direct ancestors of
        // the source/target node, or (2) nodes that contain the source/target point.
        var traversableNodes = new Set([edge.source.node, edge.target.node].concat(_toConsumableArray(_this.storage.ancestors([edge.source.node, edge.target.node])), _toConsumableArray(_this.storage.nodes().filter(function (n) {
          var nbounds = n.shape.bounds();
          return boundsContain(nbounds, edge.source.point.x, edge.source.point.y) || boundsContain(nbounds, edge.target.point.x, edge.target.point.y);
        }))));

        function isVertexTraversable(vertex) {
          return vertex.node === undefined || traversableNodes.has(vertex.node);
        }

        var traversableVertices = vertices.filter(isVertexTraversable);
        var traversableVerticesIdx = new Map(traversableVertices.map(function (vertex, idx) {
          return [vertex, idx];
        })); // Perform A* search for optimal routes.

        var start = portToVertex.get(edge.source.point);
        var end = portToVertex.get(edge.target.point);
        if (start === undefined || end === undefined) throw new Error("Vertex not found");
        var cache = new Map();
        var frontier = new fastpriorityqueue_1.default(function (a, b) {
          return cache.get(a).cost < cache.get(b).cost;
        });
        Object.entries(start.neighbors).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              dir = _ref3[0],
              _ = _ref3[1];

          var startKey = "".concat(traversableVerticesIdx.get(start), "-").concat(dir);
          cache.set(startKey, {
            vertex: start,
            direction: dir,
            length: 0,
            bends: 0,
            penalty: 0,
            cost: costFn(lengthHeuristic(start, end), bendsHeuristic(start, end), 0),
            backlink: undefined
          });
          frontier.add(startKey);
        });

        var _loop2 = function _loop2() {
          var currKey = frontier.poll();
          if (currKey === undefined) return "break";

          var _cache$get = cache.get(currKey),
              vertex = _cache$get.vertex,
              direction = _cache$get.direction,
              length = _cache$get.length,
              bends = _cache$get.bends,
              penalty = _cache$get.penalty;

          if (vertex === end) {
            // Reconstruct path for the edge.
            var ptr = currKey;
            var route = [];

            while (ptr !== undefined) {
              var _cache$get2 = cache.get(ptr),
                  _vertex = _cache$get2.vertex,
                  backlink = _cache$get2.backlink;

              route.push(_vertex);
              ptr = backlink;
            }

            routes.set(edge, route.reverse());
            return {
              v: void 0
            };
          }

          Object.entries(vertex.neighbors).forEach(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                dir = _ref5[0],
                neighbor = _ref5[1];

            if (dir === directionReverse[direction]) return;
            if (neighbor === undefined || !isVertexTraversable(neighbor)) return;
            var neighborKey = "".concat(traversableVerticesIdx.get(neighbor), "-").concat(dir);
            var neighborLength = manhattanDistance(vertex, neighbor);
            var neighborBends = dir === direction ? 0 : 1;
            var neighborPenalty = 0; // neighborLength * (neighbor.node ? (neighbor.node === start.node || neighbor.node === end.node ? kSourceTargetPenalty : kOverlapPenalty) : 0);

            if (neighbor.node && vertex.node === neighbor.node) {
              if (neighbor.node === start.node && !_this.storage.hasDescendant(start.node, end.node)) {
                neighborPenalty += kSourceTargetPenalty;
              } else if (neighbor.node === end.node && !_this.storage.hasAncestor(start.node, end.node)) {
                neighborPenalty += kSourceTargetPenalty;
              }
            }

            if (neighbor.node && vertex.node) {
              neighborPenalty += kOverlapPenalty;
            }

            neighborPenalty *= neighborLength;
            var neighborCost = costFn(length + neighborLength + lengthHeuristic(neighbor, end), bends + neighborBends + bendsHeuristic(neighbor, end), penalty + neighborPenalty);
            var existing = cache.get(neighborKey);

            if (!existing || existing.cost > neighborCost) {
              // For every (vertex, direction) tuple, ensure only the one with the lowest
              // cost stays in frontier open set.
              cache.set(neighborKey, {
                vertex: neighbor,
                direction: dir,
                length: length + neighborLength,
                bends: bends + neighborBends,
                penalty: penalty + neighborPenalty,
                cost: neighborCost,
                backlink: currKey
              });
              frontier.add(neighborKey);
            }
          });
        };

        _loop: while (!frontier.isEmpty()) {
          var _ret = _loop2();

          switch (_ret) {
            case "break":
              break _loop;

            default:
              if (typeof _ret === "object") return _ret.v;
          }
        }

        console.warn("No route found for edge: ".concat(edge.id));
      });
      console.log(routes); // =========================================================================================
      // Phase 3: Get nudged routes.
      // TODO
      // =========================================================================================
      // Phase 4: Convert routes to edge paths.

      console.log("Phase 4: Convert routes to edge paths.");
      this.storage.edges().forEach(function (edge) {
        var route = routes.get(edge);
        if (!route || route.length <= 2) return; // Merge consecutive horizontal/vertical segments.

        var colinear = function colinear(a, b, c) {
          return Math.abs((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x)) < 0.001;
        };

        var prev = new optim_1.Vector(route[0].x, route[0].y);
        var path = [prev];

        for (var i = 1; i < route.length; i++) {
          var curr = new optim_1.Vector(route[i].x, route[i].y);
          var next = i + 1 < route.length ? new optim_1.Vector(route[i + 1].x, route[i + 1].y) : null;

          if (!next || !colinear(prev, curr, next)) {
            path.push(curr);
            prev = curr;
          }
        }

        edge.path = path;
      });
    }
  }]);

  return OrthogonalRouter;
}();

exports.OrthogonalRouter = OrthogonalRouter;